import { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onChangeFilters } from "../../../redux/features/table/tableSlice";
import { MultiSelect } from "react-multi-select-component";
import { Form, Button, Accordion, Row, Col, Modal, Table, Tabs, Tab, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Refresh from '../../../assets/images/slotplanning/refresh.svg';
import { clearAllTableFilters } from "../../../redux/features/table/tableSlice";
import { faPlus, faTruck, faBuilding, faClock, faAlarmClock, faAngleRight, faMagnifyingGlass, faFilter, faEye, faBars, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import TableFilterMorePanel from "./TableFilterMorePanel";  

const TableFilters = ({ filtersConfig = [], pref }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.table);
  // console.log('filters', filters);

  const hasFilters = Object.values(filters).some((value) => value && value.toString().trim() !== "");
  const [localValues, setLocalValues] = useState({});

  // useEffect(() => {
  //   if (localValues) {
  //     setLocalValues(filters);
  //   }
  // }, []);

  

  const debounceRef = useRef(null);

  const handleChange = (field, value) => {
    setLocalValues((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      dispatch(
        onChangeFilters({
          ...filters,
          [field]: value,
        })
      );

    }, 500);
  };
  const handleResetFilters = () => {
    dispatch(clearAllTableFilters(true));
    setLocalValues({})
    localStorage.removeItem('PreFilter')
  };

   const handleMoreApply = useCallback((pendingFilters) => {
      dispatch(onChangeFilters(pendingFilters));
    },
    [dispatch]
  );
 
    const handleMoreReset = useCallback((clearedFilters) => {
      dispatch(onChangeFilters(clearedFilters));
    },
    [dispatch]
  );

  // useEffect(() => {
  //   console.log('pref', pref);
    
  //   const preFilter = JSON.parse(localStorage.getItem('PreFilter'))
  //   if (preFilter) {
  //     setLocalValues((prev) => ({
  //       ...prev,
  //       ...preFilter
  //     }));

  //     // if (debounceRef.current) {
  //     //   clearTimeout(debounceRef.current);
  //     // }

  //     // debounceRef.current = setTimeout(() => {
  //       dispatch(
  //         onChangeFilters({
  //           ...filters,
  //           ...preFilter,
  //         })
  //       );

  //     // }, 500);
  //     // handleChange(preFilter?.field, preFilter?.value)
  //   }
  // }, [pref]);

  useEffect(() => {
    setLocalValues(filters);
  }, [filters]);


  return (
    <div className="d-flex align-items-center g-3 srclft">
      {filtersConfig.map((filter, index) => {
        if (filter.type === "button") {
          return (
            <Button onClick={filter.click} className={filter.class}>{filter.icon && <FontAwesomeIcon icon={filter.icon === 'plus' ? faPlus : ''} />} {filter.text}</Button>
          );
        }
        if (filter.type === "input") {
          return (
            <>
              <div className="src-br position-relative">
               <Form.Control
                  key={index}
                  type="text"
                  placeholder={filter.placeholder}
                  value={localValues[filter.field] || ""}
                  maxLength={filter.format === "mawb" ? 12 : undefined}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (filter.format === "mawb") {
                      value = value.replace(/\D/g, "");
                      if (value.length > 3) {
                        value = value.slice(0, 3) + "-" + value.slice(3);
                      }
                      // if (value.length > 8) {
                      //   value = value.slice(0, 8) + " " + value.slice(8);
                      // }
                      value = value.slice(0, 12);
                    }
                    handleChange(filter.field, value);
                  }}
                />
                <span className="src-br-icon">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </span>
              </div>
            </>
          );
        }
        if (filter.type === "date") {
          return (
           <div className={`src-br position-relative ${filter.class ? filter.class : ""}`}>
              <Form.Control
                key={index}
                type="date"
                placeholder={filter.placeholder}
                value={localValues[filter.field] || ""}
                onChange={(e) => {
                  handleChange(filter.field, e.target.value);
                }}
              />
            </div>
          );
        }

        if (filter.type === "multiselect") {
          const selectedValues = filters[filter.field] || [];
          // console.log('selectedValues', selectedValues);

          return (
            <>
              <div className="custom-select">
                <MultiSelect
                  key={index}
                  options={filter.options || []}
                  value={filter.options?.filter(option => selectedValues.includes(option.value)) || []}
                  onChange={(selectedOptions) => {
                    const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                    handleChange(filter.field, values);
                  }}
                  // labelledBy={filter.placeholder || "select"}
                  overrideStrings={{
                    selectSomeItems: filter.placeholder || "Select...",
                  }}
                 className={`multiselect ${filter.class || "dw-15"}`}
                />
              </div>
            </>
          );
        }
         if (filter.type === "morefilter") {
          return (
            <TableFilterMorePanel
              key={index}
              config={filter.more || []}
              filters={filters}
              onApply={handleMoreApply}
              onReset={handleMoreReset}
            />
          );
        }

        return null;
      })}
      {hasFilters && (
        <div className="rstflr">
          <button onClick={handleResetFilters}>
            <img src={Refresh} alt="reset" /> Reset Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default TableFilters;